<template>
  <div class="login">
    <div class="content">
      <div class="left">
        <img src="/images/pages/login/login-logo.png" alt="Fibra Experts">

        <div class="texts">
          <h1>Portal do<br /> cliente</h1>

          <h2>
            Esta é a sua área.
            <br />
            Seja bem vindo(a) à área<br /> do cliente <strong>Fibra Experts</strong>.
            <br />
            <br />
            Este espaço foi criado para<br /> que você tenha acesso rápido<br /> e fácil a todas as informações<br /> sobre o seu <strong>Fibra Experts</strong>.
          </h2>
        </div>
      </div>

      <div class="background" />

      <form v-on:submit.prevent="onSubmit" class="right">
        <div />

        <div class="form-container">
          <template v-if="type === 'LOGIN'">
            <fieldset>
              <input type="number" required placeholder="CPF / CNPJ" v-model="modelLogin.cpf" maxlength="20">
            </fieldset>

            <fieldset>
              <input type="password" required placeholder="Senha" v-model="modelLogin.senha" maxlength="25">
            </fieldset>

            <p><button type="submit" :disabled="isLoading">Entrar</button></p>

            <p><a href="javascript:;" @click="type = 'ESQUECEU'">Esqueceu a senha?</a></p>

            <p class="feedback fail" v-if="loginFailed">Falha ao realizar o login.<br />Verifique os dados inseridos.</p>
          </template>

          <template v-if="type === 'ESQUECEU'">
            <fieldset>
              <input type="number" required placeholder="CPF / CNPJ" v-model="modelSenha.cpf" maxlength="20">
            </fieldset>

            <fieldset>
              <input type="email" required placeholder="E-mail" v-model="modelSenha.email" maxlength="100">
            </fieldset>

            <p><button type="submit" :disabled="isLoading">Recuperar senha</button></p>

            <p><a href="javascript:;" @click="type = 'LOGIN'">Efetuar login</a></p>

            <p class="feedback fail" v-if="recoverFailed">É necessário inserir o CPF e o e-mail que consta no contrato.<br />Verifique os dados preenchidos e tente novamente.</p>

            <p class="feedback success" v-if="recoverSuccess">Enviamos um e-mail para você recuperar sua senha</p>
          </template>
        </div>

        <p>
          Você também pode ligar para<br /> a Central de Relacionamentos:
          <br />
          <br />
          <strong>(11) 3506-1444</strong>
          <br />
          <strong>0800-722-7822</strong>
          <br />
          Segunda à sexta, das 9h às 18h
        </p>
      </form> <!-- /form -->
    </div> <!-- /.content -->
  </div>
</template>

<script>
import Vue from 'vue'
import Auth from '@/services/Auth'

export default {
  data () {
    const data = {
      isLoading: false,
      loginFailed: false,
      recoverFailed: false,
      recoverSuccess: false,

      type: 'LOGIN',

      modelLogin: {
        cpf: '',
        senha: ''
      },

      modelSenha: {
        cpf: '',
        email: ''
      }
    }

    return data
  }, // data()

  beforeRouteEnter (to, from, next) {
    if (Auth.isLoggedIn()) next({ path: '' })
    else next()
  }, // beforeRouteEnter()

  beforeCreate () {
    Vue.http.headers.common['Authorization'] = ''
  }, // beforeCreate()

  mounted () {
    Auth.logout(false)
    const paramsURL = this.getAllUrlParams(window.location.href)

    if (paramsURL.personifica) {
      this.loginPersonifica(paramsURL.personifica)
    }
  }, // mounted()

  methods: {
    onSubmit () {
      if (this.type === 'LOGIN') {
        return this.login()
      }

      return this.recoverPassword()
    },

    async login () {
      try {
        this.isLoading = true
        this.resetMessages()

        this.modelLogin.cpf = this.modelLogin.cpf.replace(/[^0-9]/gi, '')
        Auth.logout(false)

        let xhr = await Auth.login(this.modelLogin)

        if (xhr.Ok && xhr.Cliente) {
          return this.$router.push('/')
        } else {
          this.loginFailed = true
        }
      } catch (e) {
        console.error('Falha ao logar!', e)
        this.loginFailed = true
      } finally {
        this.isLoading = false
      }
    }, // login()

    async recoverPassword () {
      try {
        this.isLoading = true
        this.resetMessages()

        let xhr = await Auth.forget({
          cpf: this.modelSenha.cpf.replace(/[^0-9]/gi, ''),
          email: this.modelSenha.email
        })

        if (xhr.Erro === false) {
          this.recoverSuccess = true
          this.modelSenha.cpf = ''
          this.modelSenha.email = ''
        } else {
          this.recoverFailed = true
        }
      } catch (e) {
        console.error('Falha ao recuperar senha', e)
        this.recoverFailed = true
      } finally {
        this.isLoading = false
      }
    },

    async loginPersonifica (str) {
      try {
        this.isLoading = true
        this.resetMessages()

        Auth.logout(false)

        let xhr = await Auth.loginPersonifica(str)

        if (xhr.Ok) {
          return this.$router.push('/')
        } else {
          this.loginFailed = true
        }
      } catch (e) {
        console.error('Falha ao logar!', e)
        this.loginFailed = true
      } finally {
        this.isLoading = false
      }
    }, // login()

    resetMessages () {
      this.loginFailed = false
      this.recoverFailed = false
      this.recoverSuccess = false
    },

    getAllUrlParams (url) {
      let queryString = url ? url.split('?')[1] : window.location.search.slice(1)
      let obj = {}

      if (queryString) {
        queryString = queryString.split('#')[0]

        let arr = queryString.split('&')

        for (let i = 0; i < arr.length; i++) {
          let a = arr[i].split('=')

          let paramName = a[0]
          let paramValue = typeof (a[1]) === 'undefined' ? true : a[1]

          paramName = paramName
          if (typeof paramValue === 'string') paramValue = paramValue

          if (paramName.match(/\[(\d+)?\]$/)) {
            let key = paramName.replace(/\[(\d+)?\]/, '')
            if (!obj[key]) obj[key] = []

            if (paramName.match(/\[\d+\]$/)) {
              let index = /\[(\d+)\]/.exec(paramName)[1]
              obj[key][index] = paramValue
            } else {
              obj[key].push(paramValue)
            }
          } else {
            if (!obj[paramName]) {
              obj[paramName] = paramValue
            } else if (obj[paramName] && typeof obj[paramName] === 'string') {
              obj[paramName] = [obj[paramName]]
              obj[paramName].push(paramValue)
            } else {
              obj[paramName].push(paramValue)
            }
          }
        } // for
      } // if

      return obj
    } // getAllUrlParams()
  } // methods
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .login
    background: #fff
    min-height: 700px
    display: flex
    height: 100vh
    width: 100vw
    align-items: center
    justify-content: center

    .content
      max-width: 1540px
      margin: 0 auto
      display: flex
      align-items: center
      justify-content: space-between
      height: 100%
      position: relative
      padding: 0 20px
      overflow: hidden
      max-height: 963px
      width: 100%

    .left
      img
        margin-bottom: 100px
        margin-top: 50px

      .texts
        width: 525px
        padding-left: 10px

      h1
        font-size: 92px
        color: #5B8991
        font-weight: 600
        text-transform: lowercase
        font-family: 'Gotham-Bold', sans-serif
        margin-bottom: 10px

      h2
        font-family: 'Gotham-Light', sans-serif
        color: #5B8991
        padding-left: 100px
        font-size: 24px
        line-height: 28px

        strong
          font-family: 'Gotham-Bold', sans-serif
          line-height: 10px

      @media (max-width: 1350px)
        h1
          font-size: 72px

        h2
          font-size: 20px
          line-height: 24px

    .background
      position: absolute
      left: 260px
      top: 0
      bottom: 0
      width: 1300px
      height: 100%
      z-index: 100
      pointer-events: none
      background:
        image: url(/images/pages/login/background.png)
        repeat: no-repeat
        position: center right

      &:after
        content: ''
        position: absolute
        left: 218px
        top: calc(50% + 134px)
        transform: translateY(-50%)
        height: 693px
        width: 605px
        background:
          image: url(/images/pages/login/bg-x.png)
          repeat: no-repeat
          position: center
          size: contain

      @media (max-width: 1450px)
        width: 1300px
        background-size: 1077px auto
        left: 110px

        &:after
          left: 431px
          width: 430px
          height: 500px
          top: calc(50% + 113px)

      @media (max-width: 1350px)
        left: 0

    .right
      position: relative
      z-index: 200
      max-width: 350px
      display: flex
      flex-direction: column
      justify-content: space-between
      width: 100%
      height: 100%
      padding-bottom: 40px
      padding-right: 30px

      input
        background: #fff
        padding: 13px 10px 10px
        margin-bottom: 13px

        +placeholder
          color: #5C6969
          font-family: 'Gotham-Book', sans-serif

      button
        background: #E2001B
        color: #fff
        text-transform: uppercase
        font-family: 'Gotham-Bold', sans-serif
        font-size: 20px
        padding: 7px 0
        text-align: center
        cursor: pointer
        width: 100%
        margin-bottom: 13px

      a, p
        color: #fff
        text-align: center
        font-family: 'Gotham-Book', sans-serif
        font-size: 16px
        display: block

        strong
          font-family: 'Gotham-Bold', sans-serif

      a:hover
        text-decoration: underline

      p
        font-size: 20px
        line-height: 24px

        &.feedback
          color: #e2011b
          background: rgba(255, 255, 255, 0.7)
          padding: 5px 10px
          font-size: 14px
          line-height: 18px
          margin-top: 15px

          &.fail
            color: #e2011b

          &.success
            color: #0c6e1e

        strong
          font-size: 22px
          line-height: 28px

    @media (max-width: 1200px)
      .content
        flex-direction: column

        .left
          padding-bottom: 25px

          img
            margin-bottom: 50px
            margin-top: 50px

          .texts
            width: 100%
            max-width: 500px
            padding: 0

          h1
            font-size: 52px
            margin-bottom: 10px

          h2
            padding: 0

        .background
          display: none

        .right
          input
            background: #5b8991

            +placeholder
              color: #fff
</style>
